"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FutureMTAHeadUpBannerWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var portal_core_1 = require("@ferry/portal-core");
var FutureMTAHeadUpBannerWidget = /** @class */ (function (_super) {
    __extends(FutureMTAHeadUpBannerWidget, _super);
    function FutureMTAHeadUpBannerWidget(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.futureMtaCountFieldName = "uistate.futureMtaCount";
        _this.state = {
            futureMtaCount: (_a = _this.bindFromField(_this.futureMtaCountFieldName)) !== null && _a !== void 0 ? _a : 0
        };
        return _this;
    }
    FutureMTAHeadUpBannerWidget.prototype.render = function () {
        if (this.state.futureMtaCount >= 1) {
            return ((0, jsx_runtime_1.jsx)(portal_core_1.InfoBanner, { wording: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("b", { children: "Heads up" }), " - to keep things simple any further changes will need to take place ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "after" }), " your other change(s) have taken effect."] }) }));
        }
        return ((0, jsx_runtime_1.jsx)(portal_core_1.InfoBanner, { wording: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("b", { children: "Heads up" }), " - to keep things simple any further changes will need to take place ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "after" }), " this change has taken effect."] }) }));
    };
    return FutureMTAHeadUpBannerWidget;
}(plugin_journey_1.WidgetBase));
exports.FutureMTAHeadUpBannerWidget = FutureMTAHeadUpBannerWidget;
//# sourceMappingURL=FutureMTAHeadUpBannerWidget.js.map